import { render, staticRenderFns } from "./message-mark-unread.vue?vue&type=template&id=d0c9bf66&scoped=true"
import script from "./message-mark-unread.vue?vue&type=script&lang=js"
export * from "./message-mark-unread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c9bf66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c9bf66')) {
      api.createRecord('d0c9bf66', component.options)
    } else {
      api.reload('d0c9bf66', component.options)
    }
    module.hot.accept("./message-mark-unread.vue?vue&type=template&id=d0c9bf66&scoped=true", function () {
      api.rerender('d0c9bf66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/message-mark-unread.vue"
export default component.exports